
import {Component, Mixins, Prop, Ref, Watch} from 'vue-property-decorator';
import {mapGetters} from 'vuex';
import ObjectInputMixin from '@/mixins/ObjectInputMixin.vue';
import {MtsDosyaFormData} from '@/plugins/uyap-plugin/takip_ac/MtsDosyaFormData';
import ProcessWizardTemplate, {
  WizardStep,
  DropdownOption,
  ProcessWizardVideo
} from '@/components/forms/templates/ProcessWizardTemplate.vue';
import XmlController from '@/plugins/uyap-plugin/takip_ac/XmlController';
import {TaskTuru} from '@/plugins/uyap-plugin/enum/TaskTuru';
import {ProgramPaths} from '@/enum/ProgramPaths';
import MtsTakipBilgileriForm from '@/components/forms/form-wizard/eicrapro/takip-hazirla/MtsTakipBilgileriForm.vue';
import MtsTakipHazirlaniyor from '@/components/forms/form-wizard/eicrapro/takip-hazirla/MtsTakipHazirlaniyor.vue';
import Breadcrumbs from '@/components/eicrapro/shared/Breadcrumbs.vue';
import {IbanTercihiEnum} from '@/plugins/uyap-plugin/uyap/IbanTercihiEnum';
import {TakipAcStatusEnum} from '@/plugins/uyap-plugin/takip_ac/parser/TakipAcStatusEnum';
import StatBox from "@/components/eicrapro/shared/StatBox.vue";
import MtsTakipAc from '@/plugins/uyap-plugin/takip_ac/MtsTakipAc';
import NavigationGuard from "@/components/eicrapro/shared/NavigationGuard.vue";
import {
  bekleyenleriSec,
  bekleyenSayisi,
  sorguSonrasiSecim,
  xmlSorguDongusu,
  xmlSorguEngelMesaji
} from '@/utils/uyapEngelDongu';
import {uyapEngelKilidiAktifMi, UYAP_ENGEL_KAPISI_MESAJI} from '@/plugins/uyap-plugin/UyapEngeli';

export enum ActionType {
  KUYRUK_TEVZI = 'kuyrugaAktarTevziAl',
  KUYRUK_TEVZI_VE_AC = 'kuyrugaAktarTevziAlVeAc',
  HEMEN_TEVZI = 'hemenAcTevziAl',
  HEMEN_TEVZI_VE_AC = 'hemenAcTevziAlVeAc'
}

@Component({
  components: {
    NavigationGuard,
    StatBox,
    Breadcrumbs,
    MtsTakipBilgileriForm,
    ProcessWizardTemplate,
    MtsTakipHazirlaniyor,
  },
  computed: {
    ...mapGetters('mtsTakipHazirla', [
      'dosyalar',
      'isParsing',
      'isSubmitting',
      'step2Stats'
    ]),
    IbanTercihiEnum() {
      return IbanTercihiEnum;
    },
  },
})
export default class MtsTakipHazirlaFormBetaWizard extends Mixins(ObjectInputMixin) {
  readonly mtsTakipHazirlaVideos: ProcessWizardVideo[] = [
    //{
    //  url: 'https://www.youtube.com/watch?v=e5yMM7qQt_0',
    //  description: 'MTS Takip Hazırlama Rehberi'
    //},
    {
      url: 'https://www.youtube.com/watch?v=k40jFKzDtdY',
      description: 'Hash Nasıl Silinir',
      duration: '0:37'
    }
  ];

  @Ref('mtsTakipBilgileriForm') readonly mtsTakipBilgileriForm!: MtsTakipBilgileriForm;
  @Ref('wizardTemplate') readonly wizardTemplate!: ProcessWizardTemplate & {
    stepManager?: { currentStep: number; setCurrentStep: (step: number) => void }
  };
  @Ref('mtsTakipHazirlaniyor') readonly mtsTakipHazirlaniyor!: MtsTakipHazirlaniyor;

  // Breadcrumb props
  @Prop({type: Array, default: () => ['Ana Sayfa', 'MTS Takip']})
  breadcrumbItems!: string[];

  @Prop({type: Boolean, default: false})
  showBreadcrumbHomeIcon!: boolean;

  // Mixin properties (from ObjectInputMixin)
  localValue!: MtsDosyaFormData & { xml?: File | null };
  input!: () => void;

  // mapGetters type tanımlaması
  dosyalar!: MtsTakipAc[];
  isParsing!: boolean;
  isSubmitting!: boolean;

  // Local state (sadece wizard'a özel olanlar)
  xmlValidationError: string | null = null;

  @Watch('localValue', {deep: true})
  onLocalValueChange(val: MtsDosyaFormData) {
    this.$store.commit('mtsTakipHazirla/SET_FORM_DATA', val);
  }

  get secilenDosyalar(): MtsTakipAc[] {
    return this.$store.getters['mtsTakipHazirla/secilenDosyalar'] || [];
  }

  set secilenDosyalar(value: MtsTakipAc[]) {
    this.$store.commit('mtsTakipHazirla/SET_SECILEN_DOSYALAR', value);
  }

  get processingMessage(): string {
    if (this.isParsing) return 'XML dosyası işleniyor...';
    if (this.isSubmitting) return 'Takipler sıraya alınıyor...';
    return '';
  }

  get wizardSteps(): WizardStep[] {
    const baseSteps: WizardStep[] = [
      {
        id: 'step-1',
        title: 'Takip Bilgileri',
        description: 'İl, adliye, yetkili kurum ve XML dosyası seçimi',
        eyebrow: 'MTS Takip Açılışı',
        helper: '* Zorunlu alanlar',
        canContinue: (state: MtsDosyaFormData) => {
          const missingFields = this.missingRequiredFieldsStep1;
          return missingFields.length === 0;
        },
        primaryAction: {
          label: 'Devam Et',
          handler: async (state: MtsDosyaFormData) => {
            const isFormValid = this.validateStep1();
            const missingFields = this.missingRequiredFieldsStep1;

            if (!isFormValid || missingFields.length > 0) {
              if (missingFields.length > 0) {
                this.$toast.error(
                    `Lütfen şu zorunlu alanları doldurun: ${missingFields.join(', ')}`
                );
              } else {
                this.$toast.error('Lütfen tüm zorunlu alanları doldurun.');
              }
              return false;
            }

            // XML parsing kontrolü
            const vuexDosyalar = this.$store.getters['mtsTakipHazirla/dosyalar'] || [];
            const isParsing = this.$store.getters['mtsTakipHazirla/isParsing'] || false;

            const lastParsedFormDataSignature = this.$store.getters['mtsTakipHazirla/lastParsedFormDataSignature'] || '';
            const currentFormDataSignature = this.getFormDataSignature(this.localValue);
            const formDataChanged = lastParsedFormDataSignature !== currentFormDataSignature;

            if ((vuexDosyalar.length === 0 || formDataChanged) && !isParsing) {
              this.$store.commit('mtsTakipHazirla/SET_IS_PARSING', true);
              this.parseXmlFile()
                  .then((sonuc) => {
                    // UYAP engeli (DEV-3572): sorgu engelle kesildiyse sessiz başarı YOK; kalanlar "Beklemede" kalır.
                    if (sonuc && sonuc.engeleTakildi) {
                      this.$toast.warning(xmlSorguEngelMesaji(sonuc.toplam, sonuc.bekleyen), {timeout: false});
                    } else {
                      this.$toast.success('XML dosyası başarıyla işlendi');
                    }
                    this.$store.commit('mtsTakipHazirla/SET_IS_PARSING', false);
                    this.$store.commit('mtsTakipHazirla/SET_LAST_PARSED_XML_SIGNATURE', this.getXmlSignature(this.localValue.xml));
                    this.$store.commit('mtsTakipHazirla/SET_LAST_PARSED_FORM_DATA_SIGNATURE', currentFormDataSignature);
                  })
                  .catch((error: any) => {
                    this.handleError('XML parsing hatası', error);
                    this.$store.commit('mtsTakipHazirla/SET_IS_PARSING', false);
                    this.$store.commit('mtsTakipHazirla/SET_IS_RUN_QUERY', false);
                    this.$store.commit('mtsTakipHazirla/SET_SORGULANMA_DURUMU', 0);
                  });
              return true;
            }

            return true;
          }
        }
      },
      {
        id: 'step-2',
        title: 'Takip Hazırlanıyor',
        description: 'Yüklenen dosyaları kontrol edin',
        eyebrow: 'Kontrol & Hazırlık',
        canContinue: () => this.canProceedFromStep2
      }
    ];

    // Son adım için action butonları ekle
    const lastIndex = baseSteps.length - 1;
    const result = baseSteps.map((step, index) => {
      const isLast = index === lastIndex;

      if (!isLast) {
        return step;
      }

      // Son adım için özel aksiyonlar
      return {
        ...step,
        primaryAction: {
          label: 'Kuyruğa Aktar',
          hasDropdown: true,
          dropdownOptions: [
            {
              label: 'Tevzi Al',
              description: 'Ödemeyi daha sonra yapacağım',
              icon: 'mdi-inbox-arrow-down',
              handler: async () => {
                await this.takipIslemiIcinOnayAl(ActionType.KUYRUK_TEVZI);
              }
            },
            {
              label: 'Tevzi Al ve Aç',
              icon: 'mdi-rocket-launch',
              handler: async () => {
                await this.takipIslemiIcinOnayAl(ActionType.KUYRUK_TEVZI_VE_AC);
              }
            }
          ] as DropdownOption[]
        },
        secondaryActions: [
          {
            label: 'Hemen Aç',
            hasDropdown: true,
            dropdownOptions: [
              {
                label: 'Tevzi Al',
                description: 'Ödemeyi daha sonra yapacağım',
                icon: 'mdi-inbox-arrow-down',
                handler: async () => {
                  await this.takipIslemiIcinOnayAl(ActionType.HEMEN_TEVZI);
                }
              },
              {
                label: 'Tevzi Al ve Aç',
                description: '....',
                icon: 'mdi-rocket-launch',
                handler: async () => {
                  await this.takipIslemiIcinOnayAl(ActionType.HEMEN_TEVZI_VE_AC);
                }
              }
            ] as DropdownOption[],
            disabled: () => {
              // Hemen Aç için sadece dosya sayısı limiti kontrolü
              // 5'ten fazla dosya seçildiğinde disabled olmalı
              return this.secilenDosyalar.length > 5;
            },
            tooltip: () => {
              // 5'ten fazla dosya seçildiğinde tooltip göster
              if (this.secilenDosyalar.length > 5) {
                return 'Hemen Aç işlemi için en fazla 5 dosya seçebilirsiniz. 5 dosyadan fazlası için "Kuyruğa Aktar" butonunu kullanınız.';
              }
              return '';
            }
          }
        ]
      };
    });

    return result;
  }

  get canProceedFromStep2(): boolean {
    const vuexDosyalar = this.$store.getters['mtsTakipHazirla/dosyalar'] || [];
    if (!vuexDosyalar.length) return false;
    if (!this.secilenDosyalar.length) return false;
    if (this.isSubmitting) return false;
    // UYAP engelinde sorgulanmamış ("Beklemede") dosya seçili ilerlemesin (savunma; onay kutusu zaten kapalı).
    if (this.secilenDosyalar.some((d: MtsTakipAc) => d.status === TakipAcStatusEnum.QUERY_PENDING)) return false;
    return true;
  }

  get missingRequiredFieldsStep1(): string[] {
    const missing: string[] = [];

    if (!this.localValue.il) missing.push('İl');
    if (!this.localValue.adliye) missing.push('Adliye');
    if (!this.localValue.alacakliTaraf || !this.localValue.alacakliTaraf.kisiKurumId) missing.push('Yetkili Kurum');
    if (!this.localValue.mahiyetId) missing.push('Takip Mahiyeti');
    if (!this.localValue.alacakliTelefon) missing.push('Alacaklı Telefon');
    if (!this.localValue.alacakliEposta) missing.push('Alacaklı E-posta');
    if (!this.localValue.xml) missing.push('XML Dosyası');

    if (
        this.localValue.ibanTercihi === IbanTercihiEnum.Avukat &&
        !this.localValue.avukatIban
    ) {
      missing.push('IBAN Seçimi');
    }

    return missing;
  }

  validateStep1(): boolean {
    if (!this.mtsTakipBilgileriForm) {
      return false;
    }
    return this.mtsTakipBilgileriForm.validate();
  }

  // Lifecycle
  beforeMount() {
    this.$store.commit('mtsTakipHazirla/RESET_STATE');
  }

  async mounted() {
    this.localValue = new MtsDosyaFormData();
    this.input();
  }

  private getXmlSignature(file: File | null): string {
    if (!file) return '';
    return `${file.name}-${file.size}-${file.lastModified}`;
  }

  private getFormDataSignature(formData: MtsDosyaFormData): string {
    const formDataCopy = {...formData};
    delete formDataCopy.xml;
    const Crypto = require('crypto');
    const jsonString = JSON.stringify(formDataCopy);
    return Crypto.createHash('sha1').update(jsonString).digest().toString('hex');
  }

  onXmlFileSelectedSimple(file: File | null) {
    const lastParsedXmlSignature = this.$store.getters['mtsTakipHazirla/lastParsedXmlSignature'] || '';
    const currentXmlSignature = this.getXmlSignature(file);
    const xmlDegisti = lastParsedXmlSignature !== currentXmlSignature;

    if (xmlDegisti) {
      this.$store.commit('mtsTakipHazirla/SET_DOSYALAR', []);
      this.$store.commit('mtsTakipHazirla/SET_SECILEN_DOSYALAR', []);
      this.$store.commit('mtsTakipHazirla/SET_IS_RUN_QUERY', false);
      this.$store.commit('mtsTakipHazirla/SET_SORGULANMA_DURUMU', 0);
      this.$store.commit('mtsTakipHazirla/SET_LAST_PARSED_XML_SIGNATURE', '');
      this.$store.commit('mtsTakipHazirla/SET_LAST_PARSED_FORM_DATA_SIGNATURE', '');
    }

    this.xmlValidationError = null;
    this.$store.commit('mtsTakipHazirla/SET_DOSYA_VALIDASYON_HATALARI', []);
    this.input();
    this.$forceUpdate();
  }

  onXmlValidationError(message: string | null) {
    if (typeof message === 'string' && message.length) {
      this.xmlValidationError = message;
      this.$store.commit('mtsTakipHazirla/SET_DOSYA_VALIDASYON_HATALARI', [{tempId: 0, message}]);
      return;
    }
    this.xmlValidationError = null;
  }

  handleCancelOperation() {
    this.$store.commit('mtsTakipHazirla/SET_IS_CANCELLED', true);
    console.log('İşlem kullanıcı tarafından iptal ediliyor...');
  }

  async parseXmlFile(): Promise<{ dosyalar: MtsTakipAc[], engeleTakildi: boolean, toplam: number, bekleyen: number }> {
    if (!this.localValue.xml) {
      throw new Error('XML dosyası yüklenmelidir');
    }

    try {
      // 1. İlk state'leri set et (ilk await'ten önce - Step 2 loading UI hemen görünsün)
      this.$store.commit('mtsTakipHazirla/SET_SORGULANMA_DURUMU', 0);
      this.$store.commit('mtsTakipHazirla/SET_IS_RUN_QUERY', true);
      if (this.wizardTemplate?.stepManager?.currentStep === 1) {
        this.wizardTemplate.stepManager.setCurrentStep(2);
      }
      await this.$nextTick();

      // 2. XML'i oku ve parse et
      const xml = await XmlController.readXmlWithEncoded(this.localValue.xml);
      console.log("this,localvalue",Object.assign({},this.localValue));
      const parsedXml = await XmlController.mtsParse(xml, this.localValue);
      console.log("PARSED XML FIRST",Object.assign({},parsedXml));

      // Her satır önce QUERY_PENDING kurulur: UYAP engeli döngüyü keserse sorgulanmayanlar "Beklemede" kalır ve
      // "Kalanı sorgula" yalnız onları sorgular (DEV-3572). tempId = XML sırası.
      const tumDosyalar: MtsTakipAc[] = parsedXml.map((dosya, i) => {
        const takipAc = new MtsTakipAc();
        takipAc.parsedFile = dosya;
        takipAc.tempId = i + 1;
        return takipAc;
      });

      // 3. Her dosya için MTS sorgusu; engelde döngü kesilir
      const sonuc = await xmlSorguDongusu<MtsTakipAc>({
        kuyruk: bekleyenleriSec(tumDosyalar),
        engelVarMi: uyapEngelKilidiAktifMi,
        dosyayiSorgula: (d) => this.dosyayiSorgula(d),
        taze: (d) => this.tazeDosya(d),
        ilerle: async (yapilan, toplam) => {
          this.$store.commit('mtsTakipHazirla/SET_SORGULANMA_DURUMU', Math.round((100 / toplam) * yapilan));
          // Her 5 dosyada bir UI'ın render olmasını sağla
          if (yapilan % 5 === 0) {
            await this.$nextTick();
          }
        }
      });
      const sorgulanmisDosyalar: MtsTakipAc[] = tumDosyalar.map(d => sonuc.yerine.get(d.tempId) || d);

      // 4. Dosyaları Vuex'e kaydet
      this.$store.commit('mtsTakipHazirla/SET_DOSYALAR', sorgulanmisDosyalar);

      // 5. Hatalı, mükerrer uyarılı ve (UYAP engelinde) sorgulanmamış olmayanları seçili yap
      this.$store.commit('mtsTakipHazirla/SET_SECILEN_DOSYALAR', sorguSonrasiSecim(sorgulanmisDosyalar, [], null));

      // 6. İşlem tamamlandı
      this.$store.commit('mtsTakipHazirla/SET_SORGULANMA_DURUMU', 100);
      return {
        dosyalar: sorgulanmisDosyalar,
        engeleTakildi: sonuc.engeleTakildi,
        toplam: sorgulanmisDosyalar.length,
        bekleyen: bekleyenSayisi(sorgulanmisDosyalar)
      };
    } catch (error) {
      throw error;
    } finally {
      this.$store.commit('mtsTakipHazirla/SET_IS_RUN_QUERY', false);
    }
  }

  /**
   * Bir dosyayı sorgular (eski döngü gövdesinin aynısı): hata dosyayı QUERY_FAIL yapar ama döngüyü kırmaz;
   * engel kararını döngü (`xmlSorguDongusu`) verir.
   */
  private async dosyayiSorgula(takipAc: MtsTakipAc): Promise<void> {
    try {
      await takipAc.runQuery();
      console.log("takipAc Runquery",takipAc)
      if (takipAc.status !== TakipAcStatusEnum.QUERY_FAIL) {
        await takipAc.checkDuplicateTakip();
      }
    } catch (er) {
      console.log("takipAc Runquery catch",takipAc);
      takipAc.status = TakipAcStatusEnum.QUERY_FAIL;
      const errMsg = er instanceof Error
          ? er.message
          : (er && typeof er === 'object' && er.message ? String(er.message) : String(er));
      takipAc.addMessage("error", errMsg);
    }
  }

  /**
   * Uçuştaki (UYAP engeli gelirken sorgulanan) dosya KİRLİ olabilir: MtsTakipAc.runQuery taraf hatasında devam eder,
   * mükerrer kontrolü hatayı yutabilir. XML'den baştan kurulur (parse yereldir, UYAP'a gitmez); tempId = XML sırası.
   */
  private async tazeDosya(eski: MtsTakipAc): Promise<MtsTakipAc> {
    const xml = await XmlController.readXmlWithEncoded(this.localValue.xml as File);
    const hepsi = await XmlController.mtsParse(xml, this.localValue);
    const taze = new MtsTakipAc();
    taze.tempId = eski.tempId;
    taze.parsedFile = hepsi[eski.tempId - 1];
    if (!taze.parsedFile) {
      taze.status = TakipAcStatusEnum.QUERY_FAIL;
      taze.addMessage("error", "XML satırı bulunamadı");
    }
    return taze;
  }

  /** "Kalanı sorgula": YALNIZ QUERY_PENDING satırları sorgular; XML'i yeniden yüklemek gerekmez. */
  async kalaniSorgula(): Promise<void> {
    if (this.isParsing || this.isSubmitting) return;
    if (uyapEngelKilidiAktifMi()) {
      this.$toast.warning(UYAP_ENGEL_KAPISI_MESAJI);
      return;
    }
    const mevcut: MtsTakipAc[] = this.$store.getters['mtsTakipHazirla/dosyalar'] || [];
    const kuyruk = bekleyenleriSec(mevcut);
    if (!kuyruk.length) return;
    const oncekiSecim: number[] = (this.$store.getters['mtsTakipHazirla/secilenDosyalar'] || []).map((d: MtsTakipAc) => d.tempId);
    this.$store.commit('mtsTakipHazirla/SET_IS_PARSING', true);
    this.$store.commit('mtsTakipHazirla/SET_IS_RUN_QUERY', true);
    this.$store.commit('mtsTakipHazirla/SET_SORGULANMA_DURUMU', 0);
    try {
      await this.$nextTick();
      const sonuc = await xmlSorguDongusu<MtsTakipAc>({
        kuyruk: kuyruk,
        engelVarMi: uyapEngelKilidiAktifMi,
        dosyayiSorgula: (d) => this.dosyayiSorgula(d),
        taze: (d) => this.tazeDosya(d),
        ilerle: async (yapilan, toplam) => {
          this.$store.commit('mtsTakipHazirla/SET_SORGULANMA_DURUMU', Math.round((100 / toplam) * yapilan));
          if (yapilan % 5 === 0) {
            await this.$nextTick();
          }
        }
      });
      const tumu: MtsTakipAc[] = mevcut.map(d => sonuc.yerine.get(d.tempId) || d);
      this.$store.commit('mtsTakipHazirla/SET_DOSYALAR', tumu);   // eski seçimi tempId ile yeni nesnelere bağlar
      this.$store.commit('mtsTakipHazirla/SET_SECILEN_DOSYALAR',
          sorguSonrasiSecim(tumu, oncekiSecim, kuyruk.map(d => d.tempId)));
      if (sonuc.engeleTakildi) {
        this.$toast.warning(xmlSorguEngelMesaji(tumu.length, bekleyenSayisi(tumu)), {timeout: false});
      } else {
        this.$toast.success('XML dosyası başarıyla işlendi');
      }
    } catch (error) {
      this.handleError('Kalan dosyaların sorgusu', error);
    } finally {
      this.$store.commit('mtsTakipHazirla/SET_IS_PARSING', false);
      this.$store.commit('mtsTakipHazirla/SET_IS_RUN_QUERY', false);
      this.$store.commit('mtsTakipHazirla/SET_SORGULANMA_DURUMU', 0);
    }
  }

  handleError(prefix: string, error: any) {
    let errorMessage = 'Bilinmeyen bir hata oluştu';
    if (error instanceof Error) {
      errorMessage = error.message;
    } else if (typeof error === 'string') {
      errorMessage = error;
    } else if (error?.message) {
      errorMessage = error.message;
    }

    if (error.response?.data?.hash) {
      errorMessage += ` (Hash: #${error.response.data.hash})`;
    }

    console.error(`[MtsTakipHazirlaFormBetaWizard] ${prefix}:`, error);
    this.$toast.error(`${prefix}: ${errorMessage}`);
  }

  /**
   * Senaryo 1: HEMEN AÇ - TEVZİ AL
   */
  async handleHemenAcTevziAl(): Promise<void> {
    try {
      const result = await this.$store.dispatch('mtsTakipHazirla/executeSenaryo1_HemenAcTevziAl');

      // UYAP engeli (DEV-3572): döngü engelle durdu. Başarılı olanlar listeden çıkar; hatalı (uçuştaki) ve HİÇ
      // DENENMEYENLER seçili kalır. `success:false` korunur: 'tamamlandı' toast'ı ve değerlendirme dalları tetiklenmez.
      if (result.engelNedeniyleDurdu) {
        this.$toast.warning(result.message, {timeout: false});
        this.$store.commit('mtsTakipHazirla/SET_SECILEN_DOSYALAR',
            this.secilenDosyalar.filter(dosya => dosya.status !== TakipAcStatusEnum.OPEN_SUCCESS)
        );
        return;
      }

      if (result.success) {
        this.$toast.success(result.message);

        // Hatalı dosyaları filtrele
        this.$store.commit('mtsTakipHazirla/SET_SECILEN_DOSYALAR',
            this.secilenDosyalar.filter(dosya => dosya.status === TakipAcStatusEnum.OPEN_FAIL)
        );
      }
    } catch (error) {
      this.handleError('handleHemenAcTevziAl hatası', error);
    }
  }

  /**
   * Senaryo 2: HEMEN AÇ - TEVZİ AL VE AÇ
   */
  async handleHemenAcTevziAlVeAc(): Promise<void> {
    try {
      const result = await this.$store.dispatch('mtsTakipHazirla/executeSenaryo2_HemenAcTevziAlVeAc');

      // UYAP engeli (DEV-3572): döngü engelle durdu. Başarılı olanlar listeden çıkar; hatalı (uçuştaki) ve HİÇ
      // DENENMEYENLER seçili kalır. `success:false` korunur: 'tamamlandı' toast'ı ve değerlendirme dalları tetiklenmez.
      if (result.engelNedeniyleDurdu) {
        this.$toast.warning(result.message, {timeout: false});
        this.$store.commit('mtsTakipHazirla/SET_SECILEN_DOSYALAR',
            this.secilenDosyalar.filter(dosya => dosya.status !== TakipAcStatusEnum.OPEN_SUCCESS)
        );
        return;
      }

      if (result.success) {
        this.$toast.success(result.message);

        // Hatalı dosyaları filtrele
        this.$store.commit('mtsTakipHazirla/SET_SECILEN_DOSYALAR',
            this.secilenDosyalar.filter(dosya =>
                dosya.status === TakipAcStatusEnum.OPEN_FAIL
            )
        );
      }
    } catch (error) {
      this.handleError('handleHemenAcTevziAlVeAc hatası', error);
    }
  }

  /**
   * Senaryo 3 ve Senaryo 4 -> Kuyruğa Aktar - Genel Handler
   * @param actionType - İşlem tipi (tevzi al veya tevzi al ve aç)
   */
  async handleKuyrugaAktar(actionType: ActionType.KUYRUK_TEVZI | ActionType.KUYRUK_TEVZI_VE_AC): Promise<void> {
    try {
      // Task türünü belirle
      const taskTuru = actionType === ActionType.KUYRUK_TEVZI_VE_AC ? TaskTuru.mts_hizli_takip_ac : TaskTuru.mts_takip_hazirla;

      const result = await this.$store.dispatch('mtsTakipHazirla/executeSenaryo34_KuyrugaAktar', {
        actionType,
        taskTuru
      });

      // Yönlendirme (AutoPlay kontrolü)
      if (result.success) {
        const autoPlayEnabled = this.$store.getters['settings/autoPlayEnabled'];

        if (autoPlayEnabled && result.parentTaskId) {
          let path = "";
          if (result.taskTuru == TaskTuru.mts_takip_hazirla)
            path = ProgramPaths.eicrapro + '/mts-takip-hazirla-detay/' + result.parentTaskId;
          else
            path = ProgramPaths.eicrapro + '/mts-takip-ac-detay/' + result.parentTaskId;
          this.$router.push(path);
        } else {
          // AutoPlay yoksa işlemler sayfasına git
          this.$router.push(ProgramPaths.eicrapro + '/islemler');
        }
      } else {
        this.$toast.error(result.error || 'Task oluşturulamadı. Lütfen tekrar deneyin.');
      }
    } catch (error) {
      this.handleError('handleKuyrugaAktar hatası', error);
    }
  }

  /**
   * Event handler: Confirmation onaylandığında çağrılır
   */
  async handleConfirmationApproved(actionType: ActionType): Promise<void> {
    switch (actionType) {
      case ActionType.KUYRUK_TEVZI:
      case ActionType.KUYRUK_TEVZI_VE_AC:
        await this.handleKuyrugaAktar(actionType);
        break;
      case ActionType.HEMEN_TEVZI:
        await this.handleHemenAcTevziAl();
        break;
      case ActionType.HEMEN_TEVZI_VE_AC:
        await this.handleHemenAcTevziAlVeAc();
        break;
      default:
        console.warn('Bilinmeyen action type:', actionType);
        return;
    }
  }

  /**
   * Handler Wrapper'ları - Confirmation dialog gösterir, asıl işlem handleConfirmationApproved'de yapılır
   */
  async takipIslemiIcinOnayAl(actionType: ActionType): Promise<boolean> {
    try {
      const result = await this.$store.dispatch('mtsTakipHazirla/takipGonderimKontrolleri', {actionType})

      if (!result.success) {
        this.$toast.error(result.message, {timeout: false});
        return false;
      }

      this.mtsTakipHazirlaniyor.openConfirmationDialog(this.secilenDosyalar[0], actionType);

      return false;
    } catch (error) {
      this.handleError("Takip işlemi onay hatası", error);
      return false;
    }
  }
}

